import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord, query } from '@ember-data/json-api/request';
import { instrumentRoutePerformance } from '@sentry/ember';

class BacklogIdeasIdeaRoute extends Route {
  @service store;
  @service router;

  // Like the adapter's shouldBackgroundReload*: answer from the cache, and
  // refresh in the background.
  beforeModel() {
    return this.store.request(query('idea', {}, { backgroundReload: true }));
  }

  async model({ idea_id }) {
    const { content } = await this.store.request(
      findRecord('idea', idea_id, { backgroundReload: true }),
    );
    return content.data;
  }

  @action
  error(error) {
    if (error.status === 404) {
      this.router.replaceWith('backlog.ideas.list');
    } else {
      // Let the route above this handle the error.
      return true;
    }
  }
}

export default instrumentRoutePerformance(BacklogIdeasIdeaRoute);
